namespace $ {
	export class $shm_hitalama_skills_mcp extends $mol_object {
		private observer?: $mol_wire_atom<unknown, [], void>
		@ $mol_mem
		retained( next: readonly string[] = [] ) { return next }
		@ $mol_action
		retain( entry: $shm_hitalama_skills_entry ) {
			const id = entry.link().str
			this.retained( [ ...this.retained().filter( value => value !== id ), id ].slice( -32 ) )
			// MCP commands also work while the Skills page is closed. Keep a real
			// reactive root for the touched data, including native background saving.
			const observer = this.observer ??= new $mol_wire_atom( 'skills-mcp', ()=> {
				const catalog = this.$.$shm_hitalama_skills_catalog.current()
				for( const id of this.retained() ) {
					const entry = catalog?.entry( id )
					if( entry ) for( const path of entry.paths() ) entry.file_text( path )
				}
			} )
			observer.fresh()
		}
		override destructor() {
			this.observer?.destructor()
			this.observer = undefined
			super.destructor()
		}
		@ $mol_action
		handle( method: string, params: Record<string, any> ) {
			const catalog = $mol_wire_sync( this.$.$shm_hitalama_skills_catalog ).ensure()
			if( method === 'skill_create' ) {
				if( typeof params.description !== 'string' || !params.description.trim() || params.description.length > 1024 ) throw new Error( 'Укажите описание скилла.' )
				const entry = $mol_wire_sync( catalog ).create( params, 'skill', String( params.name ) )
				this.retain( entry )
				const text = this.$.$shm_hitalama_skills_yaml.update( entry.document(), params.name, params.description )
				$mol_wire_sync( entry ).file_write( 'SKILL.md', text )
				return { name: params.name, id: entry.link().str, text }
			}
			if( method !== 'skill_write' ) throw new Error( 'Неизвестная команда скиллов.' )
			const matches = catalog.entries().filter( entry => !entry.group() && ( this.$.$mol_error_fence( ()=> entry.metadata().name, ()=> entry.name() ) ) === params.name )
			if( matches.length !== 1 ) throw new Error( 'Скилл не найден или имя неоднозначно.' )
			const entry = matches[0], path = this.$.$shm_hitalama_skills_yaml.path( String( params.path || 'SKILL.md' ) )
			this.retain( entry )
			if( typeof params.text !== 'string' || typeof params.expected !== 'string' ) throw new Error( 'Нужны text и expected из свежего чтения.' )
			if( !entry.can_change() ) throw new Error( 'Нет прав на изменение скилла.' )
			const previous = entry.file_text( path )
			if( previous !== params.expected && previous !== params.text ) throw new Error( 'Файл изменился. Прочитайте его повторно.' )
			if( previous !== params.text ) $mol_wire_sync( entry ).file_write( path, params.text )
			return { name: params.name, path, saved: true, chars: params.text.length }
		}
	}
}
